// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"177":"OpenDataPolicy","274":"Home"}[chunkId] + "." + {"177":"da785f90","274":"5eb86ca0"}[chunkId] + ".css";
};